export const LANGUAGES = [
  'English', 
  'Arabic', 
  'Bahasa Indonesia', 
  'Brazilian Portuguese', 
  'Bangla', 
  'Spanish', 
  'French', 
  'Italian', 
  'German', 
  'Vietnamese',
  'Hindi'
];

export const LANGUAGE_MAP = {
  'English': 'en',
  'Arabic': 'ar',
  'Bangla': 'bn',
  'Spanish': 'es',
  'Hindi': 'hi',
  'Bahasa Indonesia': 'id',
  'Brazilian Portuguese': 'pt',
  'French': 'fr',
  'Italian': 'it',
  'German': 'de',
  'Vietnamese': 'vi'
};

export const LANGUAGE_FLAGS = {
  'English': '🇺🇸',
  'Arabic': '🇸🇦',
  'Bangla': '🇧🇩',
  'Spanish': '🇪🇸',
  'Hindi': '🇮🇳',
  'Bahasa Indonesia': '🇮🇩',
  'Brazilian Portuguese': '🇧🇷',
  'French': '🇫🇷',
  'Italian': '🇮🇹',
  'German': '🇩🇪',
  'Vietnamese': '🇻🇳'
};

export const REVERSE_LANGUAGE_MAP = Object.fromEntries(
  Object.entries(LANGUAGE_MAP).map(([key, value]) => [value, key])
);